import React, {useCallback, useEffect, useReducer, useState} from "react";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button"
import Table, {TableCell, TableRow} from "@amzn/meridian/table"
import {PackageListReducer} from "./reducers/PackageListReducer";
import Loader from "@amzn/meridian/loader";
import Checkbox from "@amzn/meridian/checkbox"
import minusIconTokens from "@amzn/meridian-tokens/base/icon/minus"
import Alert from "@amzn/meridian/alert";
import Column from "@amzn/meridian/column";
import {FormattedMessage} from "react-intl";
import Pagination from "@amzn/meridian/pagination";
import {PrintSheetDialog} from "./PrintSheetDialog";

const PACKAGE_ATTRIBUTES = [
    ["TRACKING_ID", {stringId: "tracking_id"}],
    ["EXCEPTION_STATE", {stringId: "shipment_type"}],
    ["CATEGORY", {stringId: "state"}],
    ["OPERATION_PERSON", {stringId: "reason"}],
];

const PAGE_SIZE = 500;

const initialState = {
    packages: [],
    loading: false,
    success: true
};

export const TransferSheet = (props) => {
    const [{packages, loading, success}, dispatch] = useReducer(PackageListReducer, initialState);
    const [openCASDialog, setOpenCASDialog] = useState(false);
    const onClickCASButton = useCallback(() => setOpenCASDialog(true), []);
    const [checked, setChecked] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const pageCount = Math.ceil(packages.length/PAGE_SIZE);

    const currentPagePackages = packages.slice( (currentPage - 1)*PAGE_SIZE, currentPage*PAGE_SIZE );

    useEffect(() => {
        const filters = props.filters;
        dispatch({
            type: "LOAD_DATA",
            data: {filters, dispatcher: dispatch}
        })
    }, []);
    const onCheckChanged = (key) => {
        const newRow = currentPagePackages[key].TRACKING_ID;
        checked.includes(newRow) ? setChecked(old => old.filter(row => row !== newRow)) : setChecked(old => [...old, newRow]);
    };
    const isCheckedRow = (index) => {
        return checked.includes(currentPagePackages[index].TRACKING_ID) === true;
    };
    const areAllRowsChecked = () => {
        return checked.length === currentPagePackages.length;
    };
    const checkAllRows = (e) => {
        currentPagePackages.map(item => {
            if (e) {
                checked.includes(item.TRACKING_ID) ?
                    setChecked(old => [...old]) : setChecked(old => [...old, item.TRACKING_ID]);
            } else if(!e){
                setChecked([]);
            }
            return true;
        });

    };
    if (loading) {
        return (<Row alignmentHorizontal="center" alignmentVertical="center" height="100%" minHeight="460px">
            <Loader type="circular"/>
        </Row>)
    }
    if (!success) {
        return (<Row alignmentHorizontal="center" alignmentVertical="center" height="100%" minHeight="460px">
            <Alert type="error"></Alert>
        </Row>)
    }
    return (
        <Column spacingInset="small large">
            <Box>
                <Row width="100%" widths="fill" spacing="medium" spacingInset="medium">
                    <Column>
                        <Text type="h600"><FormattedMessage id="print.transfer_packages_list"
                                                            defaultMessage="Transfer Packages List"/></Text>
                    </Column>
                    <Column>
                        <Row alignmentHorizontal="right">
                            <Button onClick={onClickCASButton} disabled={checked.length === 0} type="tertiary">
                                <FormattedMessage id="print.transfer_sheet" defaultMessage="Print Transfer Sheet"/></Button>
                        </Row>
                    </Column>
                </Row>
                <Box>
                    <Table headerRows={1} spacing="small">
                        <HeaderRow isChecked={areAllRowsChecked} checkAll={checkAllRows}/>
                        {currentPagePackages.map((item, index) => (
                            <TableRow key={item.TRACKING_ID}>
                                <TableCell>
                                    <Checkbox checked={isCheckedRow(index)} onChange={(e) => onCheckChanged(index, e)}
                                              />
                                </TableCell>
                                {
                                    PACKAGE_ATTRIBUTES.map(([a, b], index) => {
                                        return (<TableCell key={index}>{item[a]}</TableCell>);
                                    })
                                }
                            </TableRow>
                        ))}
                    </Table>
                </Box>
                {openCASDialog && <PrintSheetDialog isModalOpen={openCASDialog} onModelOpenChange={setOpenCASDialog}
                                                       checkedPackages={checked} shipmentType={currentPagePackages[0].SHIP_TYPE} />}
                <Row width="100%" widths="fill" >
                    <Box>
                        <Text type="b200" >
                            Showing { Math.min((currentPage - 1)*PAGE_SIZE + 1 , packages.length)} to {Math.min((currentPage - 1)*PAGE_SIZE + PAGE_SIZE, packages.length)} of {packages.length}
                        </Text>
                    </Box>
                    <Row alignmentHorizontal="right" >
                        { (pageCount > 1) && <Pagination
                            numberOfPages={pageCount}
                            onChange={ (e) => {
                                setChecked([]);
                                setCurrentPage(e)
                            }}
                            currentPage={currentPage}
                        />
                        }
                    </Row>
                </Row>
            </Box>
        </Column>
    )


};

function HeaderRow({isChecked, checkAll}) {
    return <TableRow key={"top"}>
        <TableCell key="selectall">
            <Checkbox checked={isChecked()} onChange={(e) => checkAll(e)} iconTokens={minusIconTokens}/></TableCell>
        <TableCell><FormattedMessage id="tracking_id" defaultMessage="Tracking Id"/></TableCell>
        <TableCell><FormattedMessage id="exception_state" defaultMessage="Exception State"/></TableCell>
        <TableCell><FormattedMessage id="category" defaultMessage="Category"/></TableCell>
        <TableCell><FormattedMessage id="operation_person" defaultMessage="Operation Person"/></TableCell>
    </TableRow>
}

HeaderRow.WrappedComponent = TableRow;


// WEBPACK FOOTER //
// ./src/components/transferSheet/TransferSheet.js